import AuthApi from '@/api/auth';
import axios from 'axios';

export default {
    namespaced: true,
    state: {
        allUsers: [],
        userData: {},
    },
    getters: {
        role: (state) => {
            if (state.userData.role_id === 1) return 'admin';
            if (state.userData.inner_role_id === '1' || state.userData.inner_role_id === 1) return 'student';
            if (state.userData.inner_role_id === '3' || state.userData.inner_role_id === 3) return 'parent';
            return 'teacher';
        },
    },
    mutations: {
        SET_USER(state, val) {
            state.userData = val;
        },
        REMOVE_USER(state) {
            state.userData = {};
        },
        SET_ALL_USERS(state, val) {
            state.allUsers = val;
        },
    },
    actions: {
        async getUser({commit}) {
            try {
                const user = await AuthApi.getUser();
                commit('SET_USER', user.data);
                return user;
            } catch (e) {
                throw e;
            }
        },

        async logIn({
                        commit,
                        dispatch,
                    }, signInData) {
            try {
                const token = await AuthApi.logIn(signInData);
                if (token.status === 200) {
                    localStorage.setItem('token', token.data);
                    axios.defaults.headers.common.Authorization = `Bearer ${token.data}`;
                    dispatch('');
                    return token.data;
                }
            } catch (e) {
                throw e;
            }
        },

        async signUp({commit}, signUpData) {
            try {
                const newUser = await AuthApi.signUp(signUpData);
                if (newUser.status === 200) {
                    localStorage.setItem('token', newUser.data);
                    axios.defaults.headers.common.Authorization = `Bearer ${newUser.data}`;
                    return newUser;
                }
            } catch (e) {
                throw e;
            }
        },

        async logOut({commit}) {
            try {
                const loggedOutUser = await AuthApi.logOut();
                commit('REMOVE_USER');
                axios.defaults.headers.common.Authorization = '';
                localStorage.removeItem('token');
                return loggedOutUser;
            } catch (e) {
                console.log(e);
            }
        },

        async getAllUsers({commit}) {
            // eslint-disable-next-line no-useless-catch
            try {
                const allUsers = await AuthApi.getUsers();
                commit('SET_ALL_USERS', allUsers.data);
                console.log(allUsers);
            } catch (e) {
                throw e;
            }
        },

        async registerTeacher({dispatch}, id) {
            // eslint-disable-next-line no-useless-catch
            try {
                const teacher = await AuthApi.registerTeacher({id});
                dispatch('getAllUsers');
                return teacher;
            } catch (e) {
                throw e;
            }
        },

        async changeUser({commit}, data) {
            try {
                const editedUser = await AuthApi.changeUserName(data);
                if (editedUser.status === 200) {
                    commit('SET_USER', editedUser.data);
                    return editedUser;
                }
                throw new Error('server error');
            } catch (e) {
                console.log(e);
                throw e;
            }
        },

        async changePassword({commit}, data) {
            try {
                const editedPassword = await AuthApi.changeUserPassword(data);
                if (editedPassword.status === 200) {
                    return editedPassword;
                }
                throw new Error('server error');
            } catch (e) {
                console.log(e);
                throw e;
            }
        },

        async resetPassword({}, email) {
            try {
                const resetPassword = await AuthApi.sendResetRequest(email);
                if (resetPassword.status === 200) {
                    return resetPassword;
                }
                throw new Error('could not reset');
            } catch (e) {
                console.log(e);
                throw e;
            }
        },
    },
};
